
export const createApiTypes = (type) => {
  return [`PENDING_${type}`, `SUCCESS_${type}`, `ERROR_${type}`]
}

